module.exports = require("rxjs/Observable");


//////////////////
// WEBPACK FOOTER
// external "rxjs/Observable"
// module id = 60
// module chunks = 0